import { render, staticRenderFns } from "./TextContributionCollection.vue?vue&type=template&id=26a434b9"
import script from "./TextContributionCollection.vue?vue&type=script&lang=js"
export * from "./TextContributionCollection.vue?vue&type=script&lang=js"
import style0 from "./TextContributionCollection.vue?vue&type=style&index=0&id=26a434b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports